import { render, staticRenderFns } from "./BaseFigures.vue?vue&type=template&id=4beffaf8"
import script from "./BaseFigures.vue?vue&type=script&lang=js"
export * from "./BaseFigures.vue?vue&type=script&lang=js"
import style0 from "./BaseFigures.vue?vue&type=style&index=0&id=4beffaf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports